<template>
  <cv-content id="main-content" style="max-width: 1200px;">
    <cv-grid fullWidth>
      <cv-row>
        <cv-column :sm="2" :md="3" :lg="8">
          <data-valida etichetta="Dalla Data"
                       v-model="parametri.dalla_data"
                       messaggio_non_valido="Data iniziale non valida" />
        </cv-column>
        <cv-column :sm="2" :md="3" :lg="8">
          <data-valida etichetta="Alla Data"
                       v-model="parametri.alla_data"
                       messaggio_non_valido="Data finale non valida" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="8">
          <cv-combo-box label="" title="Macchina"
                        :auto-filter="true"
                        v-model="modello"
                        :options="macchine"></cv-combo-box>
        </cv-column>
      </cv-row>
    </cv-grid>
    <hr/>
    <BottonieraRicerche v-on:filtra-premuto="$emit('bottone-premuto')"
                        v-on:pdf-premuto="$emit('bottone-premuto')" />
  </cv-content>
</template>

<script>
import BottonieraRicerche from "@/components/BottonieraRicerche";

export default {
  name: "RicercaUtilizzo",
  components: { BottonieraRicerche },
  data: function() {
    return {
      parametri: {
        dalla_data: "",
        alla_data: ""
      },
      modello: "",
      macchine: [
        {
          value: "1",
          label: "FIAT",
          name: "1",
        },
        {
          value: "2",
          label: "FENDT",
          name: "2",
        },
        {
          value: "3",
          label: "SAME",
          name: "3",
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>